import styled from "styled-components";
import { RowBase } from "./TableComponents";
import RowMenu from "./RowMenu";

export const Data = styled.td`
  width: ${(props) => props.width || "100%"};
  overflow-wrap: anywhere;
  margin: 0px 4px;
  text-align: ${(props) => (props.centered ? "center" : "left")};
`;

const SingleRow = styled(RowBase)`
  display: flex;
  font-weight: 800;
`;

export const DefaultRow = ({
  data,
  index,
  headers,
  onClick,
  onLimit,
  menu,
  rowHighlight,
  quickMenuOpen,
  onQuickMenuClick,
  menuOpen,
  onMouseEnterRow,
  onMouseLeaveRow,
  quickMenuOption,
}) => {
  return (
    <SingleRow
      odd={index % 2}
      highlight={rowHighlight && rowHighlight(data)}
      clickable={!!onClick}
      onMouseEnter={() => onMouseEnterRow(index)}
      onMouseLeave={() => onMouseLeaveRow(null)}
      key={index}
      onClick={() => onClick && onClick(data, index)}
    >
      {headers.map((header, index) => (
        <Data width={header.width} centered={header.centered} key={index}>
          {header.render(data)}
        </Data>
      ))}
      {menu && (
        <RowMenu
          data={data}
          index={index}
          menu={menu}
          quickMenuOpen={quickMenuOpen}
          onQuickMenuClick={onQuickMenuClick}
          menuOpen={menuOpen}
          quickMenuOption={quickMenuOption}
        />
      )}
    </SingleRow>
  );
};
